/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
import React from "react";
import { X } from "lucide-react";

const Soon = ({ isOpen, onClose, isDarkMode }) => {
  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm"
      onClick={onClose}
    >
      {/* Modal Container */}
      <div
        className={`relative rounded-2xl md:rounded-3xl p-6 sm:p-8 w-full max-w-sm sm:max-w-md shadow-2xl animate-in fade-in zoom-in-95 duration-300 ${
          isDarkMode ? "bg-dark-surface" : "bg-white"
        }`}
        onClick={(e) => e.stopPropagation()}
      >
        <button
          onClick={onClose}
          className={`absolute top-4 right-4 sm:top-6 sm:right-6 p-2 sm:p-2.5 rounded-full transition-all ${
            isDarkMode
              ? "hover:bg-dark-background text-dark-text"
              : "hover:bg-gray-100 text-gray-700"
          }`}
          aria-label="Close modal"
        >
          <X size={20} className="sm:size-[26px]" />
        </button>

        {/* Modal Content */}
        <div className="text-center pt-2">
          {/* Title */}
          <h2
            className={`text-xl sm:text-2xl font-bold mb-3 sm:mb-4 pr-8 ${
              isDarkMode ? "text-dark-text" : "text-gray-900"
            }`}
          >
            Premium Features Coming Soon!
          </h2>

          {/* Description */}
          <p
            className={`text-sm sm:text-base leading-relaxed ${
              isDarkMode ? "text-dark-muted" : "text-gray-600"
            }`}
          >
            We&apos;re crafting an enhanced experience with exclusive features
            for our Pro members.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Soon;
